import { useParams } from 'react-router-dom';
import React, { Suspense } from 'react';
import { FormContainer } from '../../CreateRoutes/CreateForm.styles';
import { AuthCheckAdmin } from '../../../Utils/AuthCheck/AdminCheck.auth';
const BreadCrumbs = React.lazy(
  () => import('../../../Components/Breadcrumbs/BreadcrumbsComponent.component')
);
import CourseEditInnerComponent from './CourseEditInner.component';
const HelmetHelper = React.lazy(
  () => import('../../../Components/PageHelmet/HelmetHelper.component')
);
import CourseDataProvider from '../../../Utils/Courses/CourseDataProvider';
// Form for editing a course
const EditCourse = () => {
  const { id } = useParams();

  return (
    <AuthCheckAdmin>
      <Suspense fallback={<p>Loading page...</p>}>
        <HelmetHelper title="Edit Course" description="Form to edit a course" />
      </Suspense>
      <FormContainer>
        <Suspense fallback={<p>Loading breadcrumbs...</p>}>
          <BreadCrumbs
            one="Admin Dashboard"
            oneLink="/admin"
            two="Edit Course"
          />
        </Suspense>
        <h2>Edit Course</h2>
        <CourseDataProvider courseId={id}>
          {(course) => <CourseEditInnerComponent c={course} id={id} />}
        </CourseDataProvider>
      </FormContainer>
    </AuthCheckAdmin>
  );
};

export default EditCourse;
